import React, { useEffect, useState } from "react";
import { Button, Col, Row, Space } from "antd";
import {
  ThemeButton,
  ThemeFilterBtn,
  XThemeSelect,
} from "../../../Styles/Theme";
import {
  ArrowRightOutlined,
  CloseOutlined,
  HolderOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import {
  ThemeCoverBox,
  ThemeFitToScreenCard,
  ThemePreviewTabs,
  ThemeStepsWrapper,
} from "../../SurveysStyle";
import { ThemeQstName, ThemeQstTitle } from "../QstFormat/QstStyle";
import {
  CheckBoxButtons,
  DragListElement,
  QstType,
  RadioButtons,
  Rating,
} from "../QstFormat/QstFormat";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";

const DesktopPreview = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  const totalSteps = 4;
  const progress = ((currentStep + 1) / totalSteps) * 100;

  const nextStep = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
      setSelectedOption(null);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setSelectedOption(null);
    }
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  // Sortable Question Card Component
  const SortableQuestionCard = ({ question }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: question.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
    };

    return (
      <ThemeCoverBox
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={`mb-3 ${question.id === "q1" ? "background" : ""}`}
        title={
          <Row gutter={[16, 16]} align="middle">
            <Col xs={20}>{question.title}</Col>
            <Col xs={4} className="text-end">
              <Button
                type="text"
                size="small"
                icon={<img src="/images/delete-icon.svg" alt="Delete" />}
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={2}>
            <img src={question.icon} alt="" />
          </Col>
          <Col xs={20}>
            <div className="defaultCardText">{question.text}</div>
          </Col>
          <Col xs={2} className="text-end">
            <div {...listeners} className="dragPointer">
              <HolderOutlined />
            </div>
          </Col>
        </Row>
      </ThemeCoverBox>
    );
  };

  const [questions, setQuestions] = useState([
    {
      id: "q1",
      title: "Questions 1",
      text: "Do you believe climate change is a serious threat to the United States?",
      icon: "/images/user-experience-icon.svg",
    },
    {
      id: "q2",
      title: "Question 2",
      text: "How concerned are you personally about the effects of climate change in your lifetime?",
      icon: "/images/radio-icon.svg",
    },
    {
      id: "q3",
      title: "Question 3",
      text: "Which of the following environmental policies do you support?",
      icon: "/images/check-box-icon.svg",
    },
    {
      id: "q4",
      title: "Question 4",
      text: "Who should take the lead in addressing climate change?",
      icon: "/images/radio-icon.svg",
    },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setQuestions((prevQuestions) => {
        const activeIndex = prevQuestions.findIndex(
          (question) => question.id === active.id
        );
        const overIndex = prevQuestions.findIndex(
          (question) => question.id === over.id
        );

        const newQuestions = [...prevQuestions];
        const [removed] = newQuestions.splice(activeIndex, 1);
        newQuestions.splice(overIndex, 0, removed);

        return newQuestions;
      });
    }
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 16, offset: 4 }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              {currentStep === 0 && (
                <ThemeFitToScreenCard className="previewWrapper previewCenterAlign">
                  <ThemeQstTitle>
                    <span className="grayBG">Q1</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Do you believe climate change is a serious threat to the
                    United States?
                  </ThemeQstName>
                  <Rating />
                  <ThemeButton
                    className="primary mt-6"
                    size="large"
                    onClick={nextStep}
                  >
                    Submit
                  </ThemeButton>
                </ThemeFitToScreenCard>
              )}
              {currentStep === 1 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q2</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <RadioButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 2 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q3</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <CheckBoxButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 3 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q4</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <DragListElement />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 4 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q5</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Select Question
                  </ThemeQstName>
                  <QstType />
                </ThemeFitToScreenCard>
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={24} className="text-end">
          <ThemeButton
            className="noBackground me-3"
            size="large"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={prevStep}
            disabled={currentStep === 0}
          />
          <ThemeButton
            size="large"
            shape="circle"
            icon={<ArrowRightOutlined />}
            className="primary"
            onClick={nextStep}
          />
        </Col>
      </Row>
    </>
  );
};

const TabletView = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  const totalSteps = 4;
  const progress = ((currentStep + 1) / totalSteps) * 100;

  const nextStep = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
      setSelectedOption(null);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setSelectedOption(null);
    }
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  // Sortable Question Card Component
  const SortableQuestionCard = ({ question }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: question.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
    };

    return (
      <ThemeCoverBox
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={`mb-3 ${question.id === "q1" ? "background" : ""}`}
        title={
          <Row gutter={[16, 16]} align="middle">
            <Col xs={20}>{question.title}</Col>
            <Col xs={4} className="text-end">
              <Button
                type="text"
                size="small"
                icon={<img src="/images/delete-icon.svg" alt="Delete" />}
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={2}>
            <img src={question.icon} alt="" />
          </Col>
          <Col xs={20}>
            <div className="defaultCardText">{question.text}</div>
          </Col>
          <Col xs={2} className="text-end">
            <div {...listeners} className="dragPointer">
              <HolderOutlined />
            </div>
          </Col>
        </Row>
      </ThemeCoverBox>
    );
  };

  const [questions, setQuestions] = useState([
    {
      id: "q1",
      title: "Questions 1",
      text: "Do you believe climate change is a serious threat to the United States?",
      icon: "/images/user-experience-icon.svg",
    },
    {
      id: "q2",
      title: "Question 2",
      text: "How concerned are you personally about the effects of climate change in your lifetime?",
      icon: "/images/radio-icon.svg",
    },
    {
      id: "q3",
      title: "Question 3",
      text: "Which of the following environmental policies do you support?",
      icon: "/images/check-box-icon.svg",
    },
    {
      id: "q4",
      title: "Question 4",
      text: "Who should take the lead in addressing climate change?",
      icon: "/images/radio-icon.svg",
    },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setQuestions((prevQuestions) => {
        const activeIndex = prevQuestions.findIndex(
          (question) => question.id === active.id
        );
        const overIndex = prevQuestions.findIndex(
          (question) => question.id === over.id
        );

        const newQuestions = [...prevQuestions];
        const [removed] = newQuestions.splice(activeIndex, 1);
        newQuestions.splice(overIndex, 0, removed);

        return newQuestions;
      });
    }
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 20, offset: 2 }}
          md={{ span: 12, offset: 6 }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              {currentStep === 0 && (
                <ThemeFitToScreenCard className="previewWrapper previewCenterAlign">
                  <ThemeQstTitle>
                    <span className="grayBG">Q1</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Do you believe climate change is a serious threat to the
                    United States?
                  </ThemeQstName>
                  <Rating />
                  <ThemeButton
                    className="primary mt-6"
                    size="large"
                    onClick={nextStep}
                  >
                    Submit
                  </ThemeButton>
                </ThemeFitToScreenCard>
              )}
              {currentStep === 1 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q2</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <RadioButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 2 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q3</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <CheckBoxButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 3 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q4</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <DragListElement />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 4 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q5</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Select Question
                  </ThemeQstName>
                  <QstType />
                </ThemeFitToScreenCard>
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={24} className="text-end">
          <ThemeButton
            className="noBackground me-3"
            size="large"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={prevStep}
            disabled={currentStep === 0}
          />
          <ThemeButton
            size="large"
            shape="circle"
            icon={<ArrowRightOutlined />}
            className="primary"
            onClick={nextStep}
          />
        </Col>
      </Row>
    </>
  );
};

const MobileView = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  const totalSteps = 4;
  const progress = ((currentStep + 1) / totalSteps) * 100;

  const nextStep = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
      setSelectedOption(null);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setSelectedOption(null);
    }
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  // Sortable Question Card Component
  const SortableQuestionCard = ({ question }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: question.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      boxShadow: isDragging ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
    };

    return (
      <ThemeCoverBox
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={`mb-3 ${question.id === "q1" ? "background" : ""}`}
        title={
          <Row gutter={[16, 16]} align="middle">
            <Col xs={20}>{question.title}</Col>
            <Col xs={4} className="text-end">
              <Button
                type="text"
                size="small"
                icon={<img src="/images/delete-icon.svg" alt="Delete" />}
              />
            </Col>
          </Row>
        }
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={2}>
            <img src={question.icon} alt="" />
          </Col>
          <Col xs={20}>
            <div className="defaultCardText">{question.text}</div>
          </Col>
          <Col xs={2} className="text-end">
            <div {...listeners} className="dragPointer">
              <HolderOutlined />
            </div>
          </Col>
        </Row>
      </ThemeCoverBox>
    );
  };

  const [questions, setQuestions] = useState([
    {
      id: "q1",
      title: "Questions 1",
      text: "Do you believe climate change is a serious threat to the United States?",
      icon: "/images/user-experience-icon.svg",
    },
    {
      id: "q2",
      title: "Question 2",
      text: "How concerned are you personally about the effects of climate change in your lifetime?",
      icon: "/images/radio-icon.svg",
    },
    {
      id: "q3",
      title: "Question 3",
      text: "Which of the following environmental policies do you support?",
      icon: "/images/check-box-icon.svg",
    },
    {
      id: "q4",
      title: "Question 4",
      text: "Who should take the lead in addressing climate change?",
      icon: "/images/radio-icon.svg",
    },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setQuestions((prevQuestions) => {
        const activeIndex = prevQuestions.findIndex(
          (question) => question.id === active.id
        );
        const overIndex = prevQuestions.findIndex(
          (question) => question.id === over.id
        );

        const newQuestions = [...prevQuestions];
        const [removed] = newQuestions.splice(activeIndex, 1);
        newQuestions.splice(overIndex, 0, removed);

        return newQuestions;
      });
    }
  };
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 20, offset: 2 }}
          md={{ span: 10, offset: 7 }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              {currentStep === 0 && (
                <ThemeFitToScreenCard className="previewWrapper previewCenterAlign">
                  <ThemeQstTitle>
                    <span className="grayBG">Q1</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Do you believe climate change is a serious threat to the
                    United States?
                  </ThemeQstName>
                  <Rating />
                  <ThemeButton
                    className="primary mt-6"
                    size="large"
                    onClick={nextStep}
                  >
                    Submit
                  </ThemeButton>
                </ThemeFitToScreenCard>
              )}
              {currentStep === 1 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q2</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <RadioButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 2 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q3</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <CheckBoxButtons />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 3 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q4</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Who should take the lead in addressing climate change?
                  </ThemeQstName>
                  <DragListElement />
                </ThemeFitToScreenCard>
              )}
              {currentStep === 4 && (
                <ThemeFitToScreenCard
                  className="previewWrapper"
                  title="Views on Climate Change & Environmental Policies"
                >
                  <ThemeQstTitle>
                    <span className="grayBG">Q5</span>
                  </ThemeQstTitle>
                  <ThemeQstName className="darkColor largeFont my-3">
                    Select Question
                  </ThemeQstName>
                  <QstType />
                </ThemeFitToScreenCard>
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={24} className="text-end">
          <ThemeButton
            className="noBackground me-3"
            size="large"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={prevStep}
            disabled={currentStep === 0}
          />
          <ThemeButton
            size="large"
            shape="circle"
            icon={<ArrowRightOutlined />}
            className="primary"
            onClick={nextStep}
          />
        </Col>
      </Row>
    </>
  );
};

export { TabletView, MobileView };
export default DesktopPreview;
